import parse from 'html-react-parser'
import { Property } from '../../../gql/graphql'
import { Checkbox, Fieldgroup, Selectfield, Textfield } from '../../_ui/forms'
import { Textareafield } from '../../_ui/forms/Textareafield'
import { EMPTY_FILTER_VALUE } from '../../types/FilterPropertyAnswer'

type PropTypes = {
  property: Property
  answer?: string | string[]
  small?: boolean
  submitOnClick?: boolean
  readonly?: boolean
  showInfotext?: boolean
  labelPadding?: boolean
  showEmptyFilterOption?: boolean
  changeAnswer: (answer: string | string[]) => void
}

export const EditMembershipFieldView = ({ readonly, property, answer, changeAnswer, small, labelPadding, showInfotext, showEmptyFilterOption }: PropTypes) => {
  switch (property.type) {
    case 'optionset': return (
      <Fieldgroup
        small={small}
        labelPadding={labelPadding}
        label={`${property.title || ''} ${property.isRequired ? '*' : ''}`}
        isRequired={property.isRequired || false}
        isPrivate={property.isPrivate || false}
      >
        {showInfotext && property.infotext && (
          <span className={'text-gray-700 text-sm'}>{parse(property.infotext)}</span>
        )}
        {(property.propertyOptions || []).map(propertyOption => propertyOption && (
          <>
            <Checkbox
              radio
              name={property.id}
              key={propertyOption.id}
              small={small}
              label={propertyOption.title}
              description={propertyOption.description || ''}
              disabled={readonly || propertyOption.disabled || false}
              isPrivate={property.isPrivate || false}
              checked={answer === propertyOption.id}
              setValue={() => changeAnswer(propertyOption.id)}
            />
          </>
        ))}
      </Fieldgroup>
    )
    case 'dropdown': return (
      <Selectfield
        small={small}
        label={`${property.title || ''} ${property.isRequired ? '*' : ''}`}
        isRequired={property.isRequired || false}
        value={answer?.toString() || ''}
        setValue={value => changeAnswer(value)}
        disabled={readonly}
        isPrivate={property.isPrivate || false}
        infotext={showInfotext ? (property.infotext || undefined) : undefined}
      >
        {showEmptyFilterOption && (
          <option value={EMPTY_FILTER_VALUE}>Leere Werte</option>
        )}
        {(property.propertyOptions || []).map(propertyOption => propertyOption && (
          <option key={propertyOption.id} value={propertyOption.id}>
            {propertyOption.title}
          </option>
        ))}
      </Selectfield>
    )
    case 'checkbox': return (
      <Fieldgroup
        small={small}
        label={`${property.title || ''} ${property.isRequired ? '*' : ''}`}
        isPrivate={property.isPrivate || false}
      >
        {showInfotext && property.infotext && (
          <span className={'text-gray-700 text-sm'}>{parse(property.infotext)}</span>
        )}
        <Checkbox
          small={small}
          label={property.title}
          checked={answer?.toString() === '1' || false}
          setValue={checked => changeAnswer(checked ? '1' : '0')}
          isRequired={property.isRequired || false}
          disabled={readonly}
          isPrivate={property.isPrivate || false}
        />
      </Fieldgroup>
    )
    case 'checkboxset': return (
      <Fieldgroup
        small={small}
        labelPadding={labelPadding}
        label={`${property.title || ''} ${property.isRequired ? '*' : ''}`}
        isRequired={property.isRequired || false}
        isPrivate={property.isPrivate || false}
      >
        {showInfotext && property.infotext && (
          <span className={'text-gray-700 text-sm'}>{parse(property.infotext)}</span>
        )}
        <span className={'grid gap-2 pt-2'}>
          {(property.propertyOptions || []).map(propertyOption => propertyOption && (
            <Checkbox
              key={propertyOption.id}
              small={small}
              label={propertyOption.title}
              description={propertyOption.description || undefined}
              disabled={readonly || propertyOption.disabled || false}
              isPrivate={property.isPrivate || false}
              checked={answer && typeof answer !== 'string' ? answer.includes(propertyOption.id) : false}
              setValue={() => {
                if (typeof answer === 'string') {
                  return []
                }

                answer?.includes(propertyOption.id)
                  ? changeAnswer(answer?.filter(id => propertyOption.id !== id))
                  : changeAnswer([...(answer || []), propertyOption.id].filter((v, i, a) => a.indexOf(v) === i))
              }}
            />
          ))}
        </span>
      </Fieldgroup>
    )
    case 'multitext': return (
      <Textareafield
        small={small}
        label={`${property.title || ''} ${property.isRequired ? '*' : ''}`}
        isRequired={property.isRequired || false}
        value={answer?.toString() || ''}
        setValue={value => changeAnswer(value)}
        disabled={readonly}
        isPrivate={property.isPrivate || false}
        infotext={showInfotext ? (property.infotext || undefined) : undefined}
      />
    )
    default: return (
      <Textfield
        small={small}
        label={`${property.title || ''} ${property.isRequired ? '*' : ''}`}
        value={answer?.toString() || ''}
        isRequired={property.isRequired || false}
        setValue={value => changeAnswer(value)}
        disabled={readonly}
        isPrivate={property.isPrivate || false}
        infotext={showInfotext ? (property.infotext || undefined) : undefined}
      />
    )
  }
}
